import { EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function EmptyStatePage404() {
  const { t } = useTranslation();
  return (
    <EmptyStateBase
      emoji={":sloth:"}
      title={t("errors:page_not_found")}
      description={t("errors:page_not_found_description")}
    />
  );
}
